import styled from "styled-components"
import media from "styled-media-query"
import Img from "gatsby-image"

export const AvatarWrapper = styled(Img)`
  border: 5px solid var(--primary);
  border-radius: 50%;
  height: 150px;
  height: 3.75rem;
  margin: auto;
  overflow: hidden;
  width: 3.75rem;

  ${media.lessThan("large")`
    height: 1.875rem;
    width: 1.875rem;
  `}
`

